<template>
  <With_Header_Modal_Template title="Услуги и цены">
    <div class="overflow_wrap">
      <template v-if="services.length > 0">
        <div class="prices" v-for="(service, service_idx) in services" :key="service_idx">

          <div class="prices__top">
            <div class="prices__top-title">{{ service.title }}</div>
            <button @click="service.isAdding = !service.isAdding">
              <img src="../../../../assets/images/icons/plus.svg" alt="">
              <span>Добавить</span>
            </button>
          </div>

          <ul class="prices__list">
            <transition-group name="slide-fade">
              <li v-for="(field, field_idx) in service.fields" :key="field_idx">
                <span class="prices__list-title">{{ field.title }}</span>
                <span class="prices__list-price">{{ field.price }} Р</span>
                <button @click="deleteField(service_idx, field.id)"><img src="../../../../assets/images/icons/trash.svg" alt=""></button>
              </li>
            </transition-group>
          </ul>

          <div class="prices__add" v-if="service.isAdding">
            <div class="prices__add-inputs">
              <input type="text" placeholder="Название" v-model="service.inp_name">
              <input type="text" placeholder="Цена" v-model="service.inp_price">
            </div>
            <button @click="addNewPrice(service_idx)">Готово</button>
          </div>

        </div>
      </template>
      <h3 v-else>Услуг нет</h3>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import { mapGetters } from 'vuex'

export default {
  name: "CabinetMasterSettingsPricesEditModal",
  components: {With_Header_Modal_Template},
  data: () => ({
    services: []
  }),
  methods: {
    addNewPrice(service_idx) {
      const {inp_name, inp_price, service_id} = this.services.find((_, idx) => idx === service_idx)
      let form = Object.assign({}, {name: inp_name, price: inp_price, specialization_id: service_id});

      this.$api.master.price.create(form).then(({data}) => {
        console.log('data', data)
        // Если добавилось на сервере -- добавляем локально
        this.services = this.services.map((s, stateServiceIdx) => {
          if (stateServiceIdx === service_idx) {
            s.inp_name = s.inp_price = ''
            s.fields.push({
              title: inp_name,
              price: inp_price,
              id: data.id,
              specialization_id: service_id
            })
          }
          return s
        })
        this.$eventHub.$emit('price.created');
      }).catch(({response}) => {
        console.log('e', response)
      })
    },
    deleteField(service_idx, price_id) {
      this.$api.master.price.destroy(price_id).then(() => {
        this.services = this.services.map((s, stateServiceIdx) => {
          if (stateServiceIdx === service_idx) {
            s.fields = s.fields.filter((price) => price.id !== price_id)
          }
          return s
        })
      })
    }
  },
  computed: mapGetters(['modalDataModal']),
  mounted() {
    const newObj = []
    const {prices, specializations} = this.modalDataModal
    specializations.forEach(specialization => {
      const specFields = []
      Object.values(prices).forEach(priceArr => {
        priceArr.forEach(({name, price, id, specialization_id}) => {
          if (specialization_id === specialization.id) {
            specFields.push({title: name, price: price, id: id})
          }
        })
      })

      newObj.push({
        title: specialization.name,
        fields: specFields,
        isAdding: false,
        inp_name: '',
        inp_price: '',
        service_id: specialization.id
      })
    })
    this.services = newObj
  }
}

</script>

<style scoped lang="scss">
.overflow_wrap {
  padding: 20px 15px;
  height: 100%;
  overflow: auto;
}

.prices {
  margin-bottom: 30px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    &-title {
      font-size: 20px;
      line-height: 1.4;
      color: #383838;
    }
    button {
      background-color: transparent;
      border: none;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 1;
        color: #B9765B;
      }
    }
  }

  &__list {
    list-style: none;

    li {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    &-title {
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
      margin-right: auto;
    }

    &-price {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
      margin-right: 10px;
    }

    button {
      background-color: transparent;
      border: none;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__add {
    &-inputs {
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        background-color: #FFFFFF;
        border: 1px solid #DBBFA7;
        border-radius: 5px;
        font-size: 16px;
        height: 40px;
        padding-left: 15px;

        &::placeholder {
          color: #808080;
        }

        &:nth-child(1) {
          width: 65%;
        }

        &:nth-child(2) {
          width: 30%;
        }
      }
    }
    button {
      margin-top: 10px;
      background-color: #DBBFA7;
      border-radius: 5px;
      border: none;
      height: 40px;
      width: 100%;
      font-weight: 600;
      font-size: 16px;
      color: #383838;
    }
  }
}

</style>
